import { FC } from "react";
import { IconPropsType } from ".";

export const Facilities: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 21V2H12V21H11ZM16.5 16.7071L13.6464 13.8536L14.3536 13.1464L17.5 16.2929V19.7929L19.1464 18.1464L19.8536 18.8536L17 21.7071L14.1464 18.8536L14.8536 18.1464L16.5 19.7929V16.7071Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 10.5H7V11.5H5.20711L9.85355 16.1464L9.14645 16.8536L4.5 12.2071V14.5H3.5V10.5Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00004 1.79291L9.85359 4.64646L9.14648 5.35357L7.50004 3.70712V5.79291L9.85359 8.14646L9.14648 8.85357L6.50004 6.20712V3.70712L4.85359 5.35357L4.14648 4.64646L7.00004 1.79291ZM16.5 1.79291L19.3536 4.64646L18.6465 5.35357L17 3.70712V8.20712L14.3536 10.8536L13.6465 10.1465L16 7.79291V3.70712L14.3536 5.35357L13.6465 4.64646L16.5 1.79291Z"
        fill={props.color}
      />
    </svg>
  );
};
